/* eslint-disable */
import { Http } from '../library';
import { httpMethods } from '../enums';
import * as Endpoints from '../constants/endpoints.constant';
import api from '../api/client';

class RealisedService {
  /**
   * Add new quotation
   * @param data
   */
  async realisedData(data, userId, partnerId) {
    const newdata = { ...data, user_id: userId, partnerId: partnerId };
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.REALISED_DATA)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  }
}

export default new RealisedService();
